import { NewDocumentType } from "client/Api/Documents/common";
import { environmentHttpClient } from "../httpClient";

export enum GlobalCreationItemKind {
	General = 0,
	Hub = 1,
	File = 2
};

export enum GeneralGlobalCreationItemKind {
	Email = 1,
	Appointment = 2,
	PersonalContact = 3,
	SharedSpace = 4
}

export type GeneralGlobalCreationItem = {
	kind: GlobalCreationItemKind.General;
	itemKind: GeneralGlobalCreationItemKind;
};

export enum HubCreationItemKind {
	Announcement = 1,
	KnowledgeItem = 2,
	Event = 3,
	Community = 4,
	CommunityPost = 5
}

export type HubCreationItem = {
	kind: GlobalCreationItemKind.Hub;
	itemKind: HubCreationItemKind;
};

export type FileGlobalCreationItem = {
	kind: GlobalCreationItemKind.File;
	itemKind: NewDocumentType;
};

export type GlobalCreationItem =
	| GeneralGlobalCreationItem
	| HubCreationItem
	| FileGlobalCreationItem;

export async function list(signal?: AbortSignal): Promise<readonly GlobalCreationItem[]> {
	return environmentHttpClient.get<readonly GlobalCreationItem[]>(
		"/UiApi/GlobalCreation",
		undefined,
		{ signal }
	);
}
